<template>
  <el-tabs
    v-model="activeTab"
    type="card"
    @tab-click="handleClick"
    @tab-remove="tabRemove"
  >
    <el-tab-pane
      v-for="(item, index) in carsList"
      :key="`tab${item.path}`"
      :label="item.name"
      :name="item.path"
      :closable="!!index"
    />
  </el-tabs>
</template>

<script>
export default {
  name: 'TabList',
  props: {
    activeName: {
      type: String,
      default: ''
    },
    carsList: {
      type: Array,
      default: () => []
    }
  },
  mounted () {
    this.activeTab = this.activeName
  },
  data () {
    return {
      activeTab: ''
    }
  },
  watch: {
    activeName (value) {
      this.activeTab = value
    }
  },
  methods: {
    handleClick (tab, event) {
      this.$emit('activeTab', tab)
    },
    tabRemove (name) {
      this.$emit('tabRemove', name)
    }
  }
}
</script>
